// BEYOND90 — global theme JS

document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      navToggle.classList.toggle('is-active');
    });
  }

  // Duplicate marquee content for a seamless infinite loop
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  // Product variant picker -> updates price / selected variant / add-to-cart form
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsJson = form.getAttribute('data-variants');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');

    form.querySelectorAll('[data-variant-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-variant-swatch]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        var variantId = btn.getAttribute('data-variant-id');
        var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
        if (!variant) return;

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Add to Cart';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-label-soldout') || 'Sold Out';
          }
        }
      });
    });
  });

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '₹' + amount;
  }
});
